import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MenuService {
    private _slimModel = new BehaviorSubject<any[]>([]);
    private _model = new BehaviorSubject<any[]>([]);
    private _menuUpdateTrigger = new BehaviorSubject<void>(undefined);

    slimModel$ = this._slimModel.asObservable();
    model$ = this._model.asObservable();
    menuUpdateTrigger$ = this._menuUpdateTrigger.asObservable();

    get slimModel(): any[] {
        return this._slimModel.value;
    }

    set slimModel(value: any[]) {
        this._slimModel.next(value);
    }

    get model(): any[] {
        return this._model.value;
    }

    set model(value: any[]) {
        this._model.next(value);
    }

    triggerMenuUpdate() {
        this._menuUpdateTrigger.next();
    }

    updateMenuItem(titleOrLabel: string, updates: any) {
        // Update in slimModel
        const slimModel = [...this._slimModel.value];
        const slimIndex = slimModel.findIndex(item => item.title === titleOrLabel || item.label === titleOrLabel);
        if (slimIndex !== -1) {
            slimModel[slimIndex] = { ...slimModel[slimIndex], ...updates };
            this._slimModel.next(slimModel);
        }

        // Update in model - need to search nested items too
        const model = [...this._model.value];
        for (let i = 0; i < model.length; i++) {
            if (model[i].items) {
                const itemIndex = model[i].items.findIndex(item => item.title === titleOrLabel || item.label === titleOrLabel);
                if (itemIndex !== -1) {
                    model[i].items[itemIndex] = { ...model[i].items[itemIndex], ...updates };
                    this._model.next(model);
                    return;
                }
            } else if (model[i].title === titleOrLabel || model[i].label === titleOrLabel) {
                model[i] = { ...model[i], ...updates };
                this._model.next(model);
                return;
            }
        }
    }

    findMenuItem(titleOrLabel: string): any {
        // Search in slimModel first
        let item = this._slimModel.value.find(item => item.title === titleOrLabel || item.label === titleOrLabel);
        if (item) return item;

        // Search in nested model items
        for (const menuGroup of this._model.value) {
            if (menuGroup.items) {
                item = menuGroup.items.find(item => item.title === titleOrLabel || item.label === titleOrLabel);
                if (item) return item;
            } else if (menuGroup.title === titleOrLabel || menuGroup.label === titleOrLabel) {
                return menuGroup;
            }
        }
        return null;
    }
}
